const Constants = {
  defaults: {
    pageCache: {
      search: null,
      sortColumn: null,
      sortDirection: null,
    },
    rowsPerPage: 100,
  },

  defaultAcceptedFileTypes: [{
      type: "image",
      ext: "png"
    }, {
      type: "image",
      ext: "jpg"
    }, {
      type: "image",
      ext: "jpeg"
    }, {
      type: "application",
      ext: "pdf"
    }],
};

export default Constants;
